import { Location } from '../model/location';
import { Prediction } from '../model/prediction';
export class LocationBuilder {
    static buildLocation(data) {
        if (data) {
            return new Location(data.lat, data.lng);
        }
        else {
            return new Location(null, null);
        }
    }
    static buildPrediction(data) {
        if (data) {
            return new Prediction(data.distance, data.duration, data.status);
        }
        else {
            return new Prediction(null, null, null);
        }
    }
}
//# sourceMappingURL=location-builder.js.map